<template>
  <div class="foot" :class="{miniWrap: platform}">
    <div class="left">      
      <ul class="banner">
        <li @click="setTab(1)">首页</li>
        <!-- <li @click="setTab(2)">经销商</li> -->
        <li @click="setTab(4)">饷店功能服务</li>
        <!-- <li @click="setTab(5)">关于我们</li> -->
      </ul>
      <div class="address">联系电话：400-8687-999</div>
      <template v-if="true">
        <div class="company">联系地址：上海市浦东新区罗山路4088弄9号楼</div>
        <div class="company">
          ©上海商量信息技术有限公司&nbsp;&nbsp;&nbsp;
          <a href="https://beian.miit.gov.cn">{{'沪ICP备18031936号'}}</a>&nbsp;&nbsp;&nbsp;
        </div>
      </template>
      <template v-else>
        <div class="company">联系地址：浙江省宁波市海曙区古林镇戴家村</div>
        <div v-if="isXiangtuan" class="company"><a target='_blank' :href="require('../assets/beian/medica.png')">互联网药品信息服务资格证书编号（浙）-经营性-2020-0018</a></div>
        <div class="company">
          ©宁波商量信息技术有限公司&nbsp;&nbsp;&nbsp;
          <a href="https://beian.miit.gov.cn">{{copy}}</a>&nbsp;&nbsp;&nbsp;
          增值电信业务经营许可证编号：{{xukezheng}}
          <a class="ePermission" target='_blank' href='http://idinfo.zjamr.zj.gov.cn/bscx.do?method=lzxx&id=3302033302030000263578'>
            <img src='http://idinfo.zjamr.zj.gov.cn//login.do?method=createLZ&id=3302033302030000263578'/>
          </a>
        </div>
      </template>
      <!-- <p>医疗器械网络交易服务第三方平台备案编号：（浙）网械平台备字[2020]第00044号</p>
      <p>浙江省网络食品销售第三方平台提供者备案编号：浙网食A33020040</p>
      <p>第二类医疗器械经营备案凭证：浙甬食药监械经营备20202435号</p>
      <p>互联网药品信息服务资格证书编号：（浙）-经营性-2020-0018</p>
      <p>出版物网络交易平台服务经营备案证：新出发浙备字第2020014号</p>
      <p>食品经营许可证：JY3302030235929</p> -->
    </div>
    <div class="right">
      <img :src="logo" alt="logo">
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import logo from 'common/img/new/logo.png'
const host = window.location.hostname;
const isInStore = host.includes('xiangdian.store');
const isAkMaxx = host.includes('ak-maxx');
const isXiangtuanmallCom = host.includes('xiangtuanmall.com');
const isXiangtuanmallCn = host.includes('xiangtuanmall.cn');
const isAifadanXyz = host.includes('aifadan.xyz');
const isXiangdianShop = host.includes('xiangdian.shop');
const isXiangdian = host.match(/xiangdian.com$/);
const isXiangdianCn = host.match(/xiangdian.com.cn$/);
const isXiangtuan = host.match(/xiangtuan.xyz$/);
let copy = '';
if (isInStore) {
  // xiangdian.store
  copy = '浙ICP备19007772号-6';
} else if (isAkMaxx) {
  if (host.includes('ak-maxx.com.cn')) {
    copy = '浙ICP备19007772号-11';
  } else if (host.includes('ak-maxx.cn')) {
    copy = '浙ICP备19007772号-13';
  } else {
    copy = '浙ICP备19007772号';
  }
  // ak-maxx.cn、ak-maxx.com、ak-maxx.com.cn
} else if (isXiangtuanmallCom) {
  // xiangtuanmall.com
  copy = '浙ICP备19007772号-3';
} else if (isXiangtuanmallCn) {
  // xiangtuanmall.cn
  copy = '浙ICP备19007772号-4';
} else if (isAifadanXyz) {
  // aifadan.xyz
  copy = '浙ICP备19007772号-8';
} else if (isXiangdianShop) {
  // xiangdian.shop
  copy = '沪ICP备18031936号-7';
} else if (isXiangdian) {
  // xiangdian.com
  copy = '沪ICP备18031936号-5';
} else if (isXiangdianCn) {
  copy = '浙ICP备19007772号-16';
} else if (isXiangtuan) {
  copy = '浙ICP备19007772号-1';
} else {
  copy = '浙ICP备19007772号'
}

let xukezheng = '合字B2-20200148';

export default {
  name: 'Foot',
  data() {
    return {
      logo: logo,
      copy,
      xukezheng,
      isXiangdian,
      isXiangtuan,
      isXiangdianShop,
      isAkMaxx
    }
  },
  computed: {
    ...mapState([
      'platform'
    ])
  },
  methods: {    
    ...mapMutations(['setName']),
    setTab(index) {
      this.setName(index)
      let pathArr = ['/', 'city', 'activity', 'shop', 'about']
      this.$router.push(pathArr[index - 1])
    },
  }
}
</script>

<style scoped lang="less">
.foot {
  width: 1000px;
  min-width: 1000px;
  height: 130px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  background: #fff;
  position: relative;
  margin: 0 auto;
  border-top: solid 1px #E6E6E6;
  .left {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    font-family: PingFangSC-Regular, sans-serif;
    .banner {
      font-size: 14px;
      color: #666;
      margin-top: 16px;
      li {
        display: inline-block;
        padding: 0 20px;
        line-height: 20px;
        position: relative;
        cursor: pointer;
        &:hover {
          color: #EC2232;
        }
        &::after {
          content: '|';
          position: absolute;
          right: 0;
          top: 1px;
          height: 16px;
          overflow: hidden;
        }
        &:last-child::after {
          content: '';
        }
        &:first-child {
          padding-left: 0;
        }
      }
    }
    .address, .company {
      color: #999;
      font-size: 12px;
      line-height: 17px;
      display: flex;
      flex-direction: row;
      align-items: center;
      a {
        color: #999;
        text-decoration: underline;
        &:active, &:hover {
          color: #999
        }
      }
    }
    .address {
      margin-top: 13px;
    }
    .company {
      margin-top: 6px;
      a{
          text-decoration: none;
          &:hover {
            color: #333;
            text-decoration: underline;
          }
        }
      }
  }
  .right {
    img {
      margin-top: 25px;
      width: 170px;
      height: 51px;
    }
  }
  .ePermission {
    display: inline-block;
    margin-left: 10px;
    height: 14px;
    img {
      width: 14px;
      height: 14px;
    }
  }
  p {
    color: #999;
    font-size: 12px;
    line-height: 1.5;
    &:last-child{
      margin-bottom: 20px;
    }
  }
}
</style>
